import { render, staticRenderFns } from "./ErrorComment.vue?vue&type=template&id=6ea3000a&scoped=true"
var script = {}
import style0 from "./ErrorComment.vue?vue&type=style&index=0&id=6ea3000a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea3000a",
  null
  
)

export default component.exports